module.exports = __webpack_public_path__ + "static/img/privacy-4.730b41e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/privacy-4.png
// module id = lHav
// module chunks = 1